import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { JiraProjectKey } from '../models/jira-project-key';

@Injectable({
  providedIn: 'root'
})
export class JiraPkeyService {
  private readonly apiUrl = `${environment.apiUrl}/v1/finance/jira-pkeys`;

  constructor(private http: HttpClient) { }

  getAll(): Observable<JiraProjectKey[]> {
    return this.http.get<JiraProjectKey[]>(this.apiUrl);
  }

  getById(id: number): Observable<JiraProjectKey> {
    return this.http.get<JiraProjectKey>(`${this.apiUrl}/${id}`);
  }

  create(dto: JiraProjectKey): Observable<JiraProjectKey> {
    return this.http.post<JiraProjectKey>(this.apiUrl, dto);
  }

  update(id: number, dto: JiraProjectKey): Observable<JiraProjectKey> {
    return this.http.put<JiraProjectKey>(`${this.apiUrl}/${id}`, dto);
  }

  toggleStatus(id: number): Observable<JiraProjectKey> {
    return this.http.patch<JiraProjectKey>(`${this.apiUrl}/${id}/status`, {});
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
